export const submitApplication = {
  pageView: () => ({
    event_name: 'page_view, journey_end, business_app_success_opf',
    page_name: 'vodapay: business advance: opf: application success',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    journey_name: 'business advance: opf: new application'
  }),

  viewApplicationStatus: () => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: applications success',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_id: 'vodapay: business advance: opf: applications success: view application status',
    journey_name: 'business advance: opf: new application'
  })
};
